import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";
import DeleteForever from "@material-ui/icons/DeleteForever";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toMomentString } from "config/util";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";
import FlipMove from "react-flip-move";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";

import { toValueLabel } from "Screen/Components/Basic/util";
import { t } from "../../services/i18n/index";
import MultiImageUpload from "../Components/Upload/MultiImageUpload";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  next_modal,
  accounts_auth_type,
  accounts,
  kyc,
  dispatch_danger,
  dispatch_post_accounts_images,
  dispatch_delete_accounts_images_id,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  // const kyc = useSelector((state) => state.reduce_get_accounts_kyc.kyc);

  const [images, set_images] = React.useState([]);

  const renderPreview = () => {
    return (
      <div className="uploadPicturesWrapper">
        <FlipMove
          enterAnimation="fade"
          leaveAnimation="fade"
          // style={{ ...styles }}
        >
          <Row>{renderPreviewPictures()}</Row>
        </FlipMove>
      </div>
    );
  };

  const renderPreviewPictures = () => {
    if (!kyc) {
      return <></>;
    }

    return Object.entries(kyc)
      .map(([key, value]) => ({
        key,
        value,
      }))
      .map((image, index) => {
        return (
          <Col xs={4} sm={4} md={4}>
            <div key={index} className="uploadPictureContainer">
              <div
                className="deleteImage"
                onClick={() => {
                  // alert(image.key);
                  dispatch_delete_accounts_images_id(
                    {
                      id: image.key,
                    },
                    () => {}
                  );
                }}
              >
                <DeleteForever />
              </div>
              <img src={image.value} className="uploadPicture" alt="preview" />
            </div>
          </Col>
        );
      });
  };

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {t("本人確認書類の表面と裏面の画像をアップロードしてください。")}
            <ul>
              <li>{t("免許証")}</li>
              <li>{t("パスポート")}</li>
              <li>{t("マイナンバーカード")}</li>
            </ul>
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <div className={"fileUploader "}>
                  <div className="fileContainer">{renderPreview()}</div>
                </div>
                {/* {kyc ? (
                  <GridImages
                    images={Object.entries(kyc).map(([key, value]) => ({
                      key,
                      value,
                    }))}
                    dispatch_delete_accounts_images_id={
                      dispatch_delete_accounts_images_id
                    }
                  />
                ) : (
                  <></>
                )} */}

                <MultiImageUpload images={images} set_images={set_images} />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      dispatch_post_accounts_images(
                        {
                          images,
                        },
                        () => {
                          close_modal();
                        }
                      );
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
